import React, { useState, useEffect, useCallback } from 'react';
import SecureFileImg from '../SecureFileImg';
import { openInAppFilePreview } from '../../utils/filePreviewBus';
import { toProtectedFileUrl } from '../../utils/secureFile';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { labelValidasi } from '../../utils/labelValidasi';
import {
  KECAMATAN,
  DESA_KELURAHAN,
  STATUS_PROSES,
  JENIS_BANTUAN,
  getDesaByKecamatan,
  isValidKecamatan,
  isValidDesa,
  getLokasiLabel
} from '../datarecap/constants';
import {
  Box, Card, CardContent, Typography, Chip, CircularProgress, Alert,
  Snackbar, Fade, Button, Stack, LinearProgress, Grid,
  useMediaQuery, TextField, MenuItem, InputAdornment,
  IconButton, Collapse, Paper, Divider, Badge, Dialog,
  DialogTitle, DialogContent, DialogActions, Avatar,
  List, ListItem, ListItemText, ListItemIcon, Table,
  TableBody, TableCell, TableContainer, TableHead, TableRow,
  Accordion, AccordionSummary, AccordionDetails, Tooltip,
  FormControl, InputLabel, Select
} from '@mui/material';
import {
  Refresh, Engineering, HomeWork, Payments, ReportProblem,
  CheckCircle, HourglassEmpty, PendingActions, NavigateBefore,
  NavigateNext, Visibility, FilterList, Clear, Search,
  Close, Person, LocationOn, Category, AttachMoney,
  CalendarToday, Phone, Receipt, Store, ShoppingCart,
  ExpandMore, Timeline, Check, Schedule, Block, Person2, PhotoCamera, CloudUpload
} from '@mui/icons-material';
import { getDashboardStats, getBantuan, getMonitoringDetail, getRabByBantuan, getProgressKeuangan, getProgressFisik, initProgressFisikPembangunan, initProgressFisikRehabilitasi, getProgressAdministrasi, initProgressAdministrasi, updateProgressKeuangan, updateProgressFisikLangkah, updateProgressAdministrasi, upsertRab, updateLangkahFormData } from '../API/bantuan';
import { mergeAdministrasiProgress, calcAdmOnlyPercent, getAdmFileUrl } from '../../utils/admProgress';
import { FilePreviewModal, FileThumbnail } from './FilePreview';
import StepUploadForm from './StepUploadForm';
import MapsBantuan from './MapsBantuan';
import FotoGallery from './FotoGallery';
import { getDocumentLabels, getFotoLabels } from '../../utils/stepTemplates';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/zoom';
// ============================================================
// HELPER FUNCTIONS
// ============================================================
const statusColor = (s) => {
  if (s === 'Selesai') return 'success';
  if (s === 'Dalam Proses') return 'warning';
  if (s === 'Belum Dimulai') return 'default';
  return 'info';
};

const statusIcon = (status) => {
  if (status === 'Selesai') return <CheckCircle fontSize="small" />;
  if (status === 'Dalam Proses') return <Schedule fontSize="small" />;
  if (status === 'Belum Dimulai') return <Block fontSize="small" />;
  return <PendingActions fontSize="small" />;
};

const formatRp = (n) => (!n && n !== 0) ? '-' : 'Rp ' + Number(n).toLocaleString('id-ID');

const formatDate = (date) => {
  if (!date) return '-';
  return new Date(date).toLocaleDateString('id-ID', {
    day: '2-digit', month: 'short', year: 'numeric'
  });
};

const calcProgressPercent = (steps) => {
  if (!steps?.length) return { presentase: 0, langkahSelesai: 0, totalLangkah: 0 };
  const totalBobot = steps.reduce((s, l) => s + (Number(l.bobot) || 0), 0);
  if (totalBobot > 0) {
    const bobotSelesai = steps.filter(l => l.status === 'Selesai').reduce((s, l) => s + (Number(l.bobot) || 0), 0);
    return {
      presentase: Math.round((bobotSelesai / totalBobot) * 100),
      langkahSelesai: steps.filter(l => l.status === 'Selesai').length,
      totalLangkah: steps.length,
    };
  }
  const langkahSelesai = steps.filter(l => l.status === 'Selesai').length;
  return {
    presentase: Math.round((langkahSelesai / steps.length) * 100),
    langkahSelesai,
    totalLangkah: steps.length,
  };
};

const calcRabPercent = (rab, admSteps = []) => {
  const admRabDone = Array.isArray(admSteps) && admSteps.some(
    (s) => Number(s.urutan) === 3 && s.status === 'Selesai'
  );
  if (admRabDone || rab?.fileRab) return { presentase: 100, langkahSelesai: 1, totalLangkah: 1 };
  if (rab) return { presentase: 25, langkahSelesai: 0, totalLangkah: 1 };
  return { presentase: 0, langkahSelesai: 0, totalLangkah: 1 };
};
const BASE_URL = process.env.REACT_APP_URL || 'http://localhost:5100';

// ============================================================
// KOMPONEN DETAIL POPUP
// ============================================================
const DetailMonitoringDialog = ({ open, onClose, bantuanId }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (open && bantuanId) {
      fetchDetail();
    }
  }, [open, bantuanId]);

  const fetchDetail = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await getMonitoringDetail(bantuanId);
      setData(res.data);
    } catch (err) {
      console.error('Error fetching detail:', err);
      setError('Gagal memuat data detail');
    } finally {
      setLoading(false);
    }
  };

  if (!open) return null;

  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      maxWidth="md" 
      fullWidth
      scroll="paper"
    >
      <DialogTitle sx={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        bgcolor: 'primary.main',
        color: 'white',
        py: 2
      }}>
        <Typography variant="h6" fontWeight={600}>
          Detail Monitoring Bantuan
        </Typography>
        <IconButton size="small" onClick={onClose} sx={{ color: 'white' }}>
          <Close fontSize="small" />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers sx={{ p: 0 }}>
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
            <CircularProgress />
          </Box>
        ) : error ? (
          <Box sx={{ p: 3 }}>
            <Alert severity="error">{error}</Alert>
          </Box>
        ) : data ? (
          <DetailContent data={data} />
        ) : (
          <Box sx={{ p: 3, textAlign: 'center' }}>
            <Typography color="text.secondary">Tidak ada data</Typography>
          </Box>
        )}
      </DialogContent>

      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose} variant="contained">
          Tutup
        </Button>
      </DialogActions>
    </Dialog>
  );
};

// ============================================================
// KOMPONEN DETAIL CONTENT
// ============================================================
// ============================================================
// KOMPONEN DETAIL CONTENT - DIPERBAIKI
// ============================================================
const DetailContent = ({ data }) => {
  const isMobile = useMediaQuery('(max-width:600px)');
  const userRole = useSelector((s) => s.authAdmin?.user?.role);
  const canUpload = ['admin', 'TFL', 'Koordinator TFL'].includes(userRole);
  const { 
    bantuan, 
    pemohon, 
    prosesBantuan, 
    langkah, 
    presentase, 
    pembelianSupplier, 
    upahtukang, 
    fotoKwitansiUpah,
    rab: rabFromApi,
    progressKeuangan: pkFromApi,
    progressFisik: pfFromApi,
    progressAdministrasi: paFromApi,
    presentasePerProses: pctFromApi,
    admBantuan: admFromApi,
  } = data;

  const fotosRumah = bantuan?.Questionnaire?.fotos || [];

  const getCoordinates = () => {
    const manualCoord = bantuan?.Questionnaire?.manualTitikKoordinatRumah;
    const coord = bantuan?.Questionnaire?.titikKoordinatRumah;
    
    let lat = null, lng = null;
    
    if (manualCoord && manualCoord.includes(',')) {
      const parts = manualCoord.split(',').map(s => s.trim());
      if (parts.length === 2) {
        const parsedLat = parseFloat(parts[0]);
        const parsedLng = parseFloat(parts[1]);
        if (!isNaN(parsedLat) && !isNaN(parsedLng)) {
          return { lat: parsedLat, lng: parsedLng };
        }
      }
    }
    
    if (coord && coord.includes(',')) {
      const parts = coord.split(',').map(s => s.trim());
      if (parts.length === 2) {
        const parsedLat = parseFloat(parts[0]);
        const parsedLng = parseFloat(parts[1]);
        if (!isNaN(parsedLat) && !isNaN(parsedLng)) {
          return { lat: parsedLat, lng: parsedLng };
        }
      }
    }
    
    if (bantuan?.latitude && bantuan?.longitude) {
      const parsedLat = parseFloat(bantuan.latitude);
      const parsedLng = parseFloat(bantuan.longitude);
      if (!isNaN(parsedLat) && !isNaN(parsedLng)) {
        return { lat: parsedLat, lng: parsedLng };
      }
    }
    
    return { lat: null, lng: null };
  };

  const coordinates = getCoordinates();

  // Group foto kwitansi berdasarkan upahTukangId
  const fotoMap = {};
  if (fotoKwitansiUpah && fotoKwitansiUpah.length > 0) {
    fotoKwitansiUpah.forEach(f => {
      if (!fotoMap[f.upahTukangId]) {
        fotoMap[f.upahTukangId] = [];
      }
      fotoMap[f.upahTukangId].push(f);
    });
  }

  // Gabungkan upah tukang dengan foto kwitansinya
  const upahWithFoto = (upahtukang || []).map(upah => ({
    ...upah,
    fotoList: fotoMap[upah.id] || []
  }));

  const [rabData, setRabData] = useState(rabFromApi || null);
  const [progressKeuangan, setProgressKeuangan] = useState(pkFromApi || []);
  const [progressFisik, setProgressFisik] = useState(pfFromApi || []);
  const [progressAdministrasi, setProgressAdministrasi] = useState(paFromApi || []);
  const [admBantuan, setAdmBantuan] = useState(admFromApi || null);
  const [rabLoading, setRabLoading] = useState(false);
  const [editStep, setEditStep] = useState(null);
  const [editStatus, setEditStatus] = useState('');
  const [editFoto, setEditFoto] = useState(null);
  const [editDokumen, setEditDokumen] = useState(null);
  const [rabKeterangan, setRabKeterangan] = useState('');
  const [rabFile, setRabFile] = useState(null);
  const [rabSaving, setRabSaving] = useState(false);
  const [preview, setPreview] = useState({ open: false, files: [], labels: [], fileBase: null, title: '' });

  const openPreview = (files, labels, fileBase, title) => {
    setPreview({ open: true, files: Array.isArray(files) ? files : [files], labels: Array.isArray(labels) ? labels : [labels], fileBase: fileBase || null, title: title || 'Preview' });
  };

  const pctRab = pctFromApi?.rab ?? calcRabPercent(rabData, progressAdministrasi);
  const mergedAdministrasi = mergeAdministrasiProgress(progressAdministrasi, admBantuan);
  const pctAdm = pctFromApi?.administrasi
    ?? (progressAdministrasi.length > 0 ? calcProgressPercent(mergedAdministrasi) : calcAdmOnlyPercent(admBantuan));
  const pctKeu = pctFromApi?.keuangan ?? calcProgressPercent(progressKeuangan);
  const pctFisik = pctFromApi?.fisik ?? calcProgressPercent(progressFisik);
  const combinedProgress = Math.round(
    (Number(pctAdm.presentase || 0) * 0.4) +
    (Number(pctKeu.presentase || 0) * 0.25) +
    (Number(pctFisik.presentase || 0) * 0.25) +
    (Number(pctRab.presentase || 0) * 0.1)
  );

  useEffect(() => {
    if (admFromApi) setAdmBantuan(admFromApi);
  }, [admFromApi]);

  useEffect(() => {
    if (!bantuan?.id) return;
    setRabLoading(true);
    (async () => {
      try {
        const rabRes = await getRabByBantuan(bantuan.id);
        const rab = rabRes.data?.data;
        if (rab) {
          setRabData(rab);
          const [pkRes, pfRes, paRes] = await Promise.allSettled([
            getProgressKeuangan(bantuan.id).catch(() => ({ data: { data: [] } })),
            getProgressFisik(bantuan.id).catch(() => ({ data: { data: [] } })),
            getProgressAdministrasi(bantuan.id).catch(() => ({ data: { data: [] } })),
          ]);
          setProgressKeuangan(pkRes.value?.data?.data || []);
          setProgressFisik(pfRes.value?.data?.data || []);
          setProgressAdministrasi(paRes.value?.data?.data || []);
        }
      } catch (e) { console.error('Fetch RAB:', e); }
      finally { setRabLoading(false); }
    })();
  }, [bantuan?.id]);

  const handleInitPembangunan = async () => {
    try {
      await initProgressFisikPembangunan(bantuan.id);
      const res = await getProgressFisik(bantuan.id);
      setProgressFisik(res.data?.data || []);
    } catch (e) { console.error(e); }
  };

  const handleInitRehabilitasi = async () => {
    const targetRabId = rabData?.id || bantuan?.id;
    if (!targetRabId) {
      console.error('Tidak ada RAB yang bisa dipakai untuk inisialisasi rehabilitasi');
      return;
    }
    const total = Number(bantuan?.nominal) || 1;
    const items = [
      { pekerjaan: 'Item Pekerjaan 1', nilai: Math.round(total * 0.3) },
      { pekerjaan: 'Item Pekerjaan 2', nilai: Math.round(total * 0.3) },
      { pekerjaan: 'Item Pekerjaan 3', nilai: Math.round(total * 0.4) },
    ];
    try {
      await initProgressFisikRehabilitasi(targetRabId, { items, totalHarga: total });
      const res = await getProgressFisik(bantuan.id);
      setProgressFisik(res.data?.data || []);
    } catch (e) { console.error(e); }
  };

  const handleInitAdministrasi = async () => {
    try {
      await initProgressAdministrasi(bantuan.id);
      const res = await getProgressAdministrasi(bantuan.id);
      setProgressAdministrasi(res.data?.data || []);
    } catch (e) { console.error(e); }
  };

  const handleUpdateProgress = async (stepId, type) => {
    const formData = new FormData();
    formData.append('status', editStatus);
    if (editFoto) {
      if (type === 'keuangan') {
        formData.append('foto', editFoto);
      } else {
        Array.from(editFoto).forEach(f => formData.append('foto', f));
      }
    }
    if (editDokumen) {
      Array.from(editDokumen).forEach(f => formData.append('dokumen', f));
    }

    try {
      if (type === 'keuangan') await updateProgressKeuangan(stepId, formData);
      else if (type === 'fisik') await updateProgressFisikLangkah(stepId, formData);
      else if (type === 'administrasi') await updateLangkahFormData(stepId, formData);

      setEditStep(null);
      setEditStatus('');
      setEditFoto(null);
      setEditDokumen(null);

      if (type === 'keuangan') {
        const res = await getProgressKeuangan(bantuan.id);
        setProgressKeuangan(res.data?.data || []);
      } else if (type === 'fisik') {
        const res = await getProgressFisik(bantuan.id);
        setProgressFisik(res.data?.data || []);
      } else if (type === 'administrasi') {
        const res = await getProgressAdministrasi(bantuan.id);
        setProgressAdministrasi(res.data?.data || []);
      }
    } catch (e) { console.error('Update progress:', e); }
  };

  const handleStepSave = async (stepId, type, formData) => {
    try {
      if (type === 'keuangan') await updateProgressKeuangan(stepId, formData);
      else if (type === 'fisik') await updateProgressFisikLangkah(stepId, formData);
      else await updateLangkahFormData(stepId, formData);
      setEditStep(null);
      if (type === 'keuangan') {
        const res = await getProgressKeuangan(bantuan.id);
        setProgressKeuangan(res.data?.data || []);
      } else if (type === 'fisik') {
        const res = await getProgressFisik(bantuan.id);
        setProgressFisik(res.data?.data || []);
      } else {
        const res = await getProgressAdministrasi(bantuan.id);
        setProgressAdministrasi(res.data?.data || []);
      }
    } catch (e) { console.error('Step save:', e); }
  };

  const openEdit = (step, type) => {
    setEditStep({ id: step.id, type });
    setEditStatus(step.status);
    setEditFoto(null);
    setEditDokumen(null);
  };

  const handleCreateRab = async () => {
    setRabSaving(true);
    try {
      await upsertRab({ BantuanId: bantuan.id, keterangan: rabKeterangan, status: 'draft' }, rabFile);
      setRabFile(null);
      setRabKeterangan('');
      const rabRes = await getRabByBantuan(bantuan.id);
      const rab = rabRes.data?.data;
      if (rab) {
        setRabData(rab);
        const [pkRes, paRes] = await Promise.allSettled([
          getProgressKeuangan(bantuan.id).catch(() => ({ data: { data: [] } })),
          getProgressAdministrasi(bantuan.id).catch(() => ({ data: { data: [] } })),
        ]);
        setProgressKeuangan(pkRes.value?.data?.data || []);
        setProgressAdministrasi(paRes.value?.data?.data || []);
      }
    } catch (e) { console.error('Create RAB:', e); }
    finally { setRabSaving(false); }
  };

  return (
    <Box sx={{ p: { xs: 2, sm: 3 } }}>
      {/* Header Info */}
      <Grid container spacing={2} sx={{ mb: 3 }}>
        <Grid item xs={12} sm={6}>
          <Paper sx={{ p: 2, bgcolor: '#f5f7fa' }}>
            <Typography variant="caption" color="text.secondary">ID Bantuan</Typography>
            <Typography variant="h6" fontWeight={600}>#{bantuan?.id}</Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Paper sx={{ p: 2, bgcolor: '#f5f7fa' }}>
            <Typography variant="caption" color="text.secondary">Status</Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Chip 
                size="medium" 
                color={statusColor(prosesBantuan?.statusProses)} 
                label={prosesBantuan?.statusProses || '-'} 
              />
              <Typography variant="body2" color="text.secondary">
                {presentase?.presentase || 0}% selesai
              </Typography>
            </Box>
          </Paper>
        </Grid>
      </Grid>

      {/* Progress Bar */}
      <Box sx={{ mb: 3 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
          <Typography variant="body2" fontWeight={500}>Progress Pengerjaan</Typography>
          <Typography variant="body2" fontWeight={600}>{combinedProgress}%</Typography>
        </Box>
        <LinearProgress 
          variant="determinate" 
          value={combinedProgress} 
          sx={{ height: 8, borderRadius: 4 }}
          color={combinedProgress >= 100 ? 'success' : 'primary'}
        />
        <Typography variant="caption" color="text.secondary">
          Gabungan progress Administrasi, Keuangan, Fisik, dan RAB
        </Typography>
      </Box>

      <Typography variant="subtitle2" fontWeight={600} sx={{ mb: 1.5 }}>Progress per Proses</Typography>
      <Grid container spacing={2} sx={{ mb: 3 }}>
        <Grid item xs={6} sm={3}><Paper sx={{ p: 1.5, bgcolor: '#f8f9fa' }}><Typography variant="caption">File RAB</Typography><Typography variant="h6" fontWeight={700}>{pctRab.presentase}%</Typography><LinearProgress variant="determinate" value={pctRab.presentase} sx={{ mt: 0.5, height: 5, borderRadius: 2 }} /></Paper></Grid>
        <Grid item xs={6} sm={3}><Paper sx={{ p: 1.5, bgcolor: '#f8f9fa' }}><Typography variant="caption">Administrasi</Typography><Typography variant="h6" fontWeight={700}>{pctAdm.presentase}%</Typography><LinearProgress variant="determinate" value={pctAdm.presentase} sx={{ mt: 0.5, height: 5, borderRadius: 2 }} color="info" /></Paper></Grid>
        <Grid item xs={6} sm={3}><Paper sx={{ p: 1.5, bgcolor: '#f8f9fa' }}><Typography variant="caption">Berkas Keuangan</Typography><Typography variant="h6" fontWeight={700}>{pctKeu.presentase}%</Typography><LinearProgress variant="determinate" value={pctKeu.presentase} sx={{ mt: 0.5, height: 5, borderRadius: 2 }} color="warning" /></Paper></Grid>
        <Grid item xs={6} sm={3}><Paper sx={{ p: 1.5, bgcolor: '#f8f9fa' }}><Typography variant="caption">Pembangunan</Typography><Typography variant="h6" fontWeight={700}>{pctFisik.presentase}%</Typography><LinearProgress variant="determinate" value={pctFisik.presentase} sx={{ mt: 0.5, height: 5, borderRadius: 2 }} color="success" /></Paper></Grid>
      </Grid>

      {!canUpload && (
        <Alert severity="info" sx={{ mb: 2 }}>Hanya Admin dan TFL yang dapat mengupload dokumen proses.</Alert>
      )}

      {/* Informasi Penerima */}
      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMore />}>
          <Typography variant="subtitle1" fontWeight={600}>
            <Person2 sx={{ mr: 1, verticalAlign: 'middle' }} />
            Informasi Penerima Bantuan
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <Typography variant="caption" color="text.secondary">Nama</Typography>
              <Typography variant="body1" fontWeight={500}>{pemohon?.nama || '-'}</Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="caption" color="text.secondary">NIK</Typography>
              <Typography variant="body1">{bantuan?.Questionnaire?.nomorKTP || pemohon?.nik || pemohon?.nomorKTP || '-'}</Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="caption" color="text.secondary">Nomor KK</Typography>
              <Typography variant="body1">{bantuan?.Questionnaire?.nomorKK || pemohon?.nomorKK || '-'}</Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="caption" color="text.secondary">Tanggal Lahir</Typography>
              <Typography variant="body1">{bantuan?.Questionnaire?.tanggallahir ? formatDate(bantuan.Questionnaire.tanggallahir) : '-'}</Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="caption" color="text.secondary">Jenis Kelamin</Typography>
              <Typography variant="body1">{bantuan?.Questionnaire?.jenisKelamin || '-'}</Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="caption" color="text.secondary">Pekerjaan</Typography>
              <Typography variant="body1">{bantuan?.Questionnaire?.pekerjaan || '-'}</Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="caption" color="text.secondary">Kecamatan</Typography>
              <Typography variant="body1">{isValidKecamatan(pemohon?.kecamatan) ? pemohon?.kecamatan : pemohon?.kecamatan || '-'}</Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="caption" color="text.secondary">Desa/Kelurahan</Typography>
              <Typography variant="body1">{isValidDesa(pemohon?.desaKelurahan) ? pemohon?.desaKelurahan : pemohon?.desaKelurahan || '-'}</Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="caption" color="text.secondary">Alamat Lengkap</Typography>
              <Typography variant="body1">{bantuan?.Questionnaire?.alamatRumah || pemohon?.alamat || bantuan?.alamatLengkap || '-'}</Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="caption" color="text.secondary">Penghasilan</Typography>
              <Typography variant="body1">{bantuan?.Questionnaire?.penghasilan != null ? formatRp(bantuan.Questionnaire.penghasilan) : '-'}</Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="caption" color="text.secondary">No. WA Penerima</Typography>
              <Typography variant="body1">{pemohon?.noWaPenerima || '-'}</Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="caption" color="text.secondary">No. Rekening</Typography>
              <Typography variant="body1">{pemohon?.noRekening || '-'}</Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="caption" color="text.secondary">Kategori</Typography>
              <Typography variant="body1">{pemohon?.kategori || '-'}</Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="caption" color="text.secondary">Skor</Typography>
              <Typography variant="body1">{pemohon?.score || '-'}</Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="caption" color="text.secondary">Koordinat Lokasi</Typography>
              <Typography variant="body1">
                {coordinates.lat && coordinates.lng ? `${coordinates.lat}, ${coordinates.lng}` : 'Koordinat tidak tersedia'}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1 }}>Foto Rumah Penerima ({fotosRumah.length})</Typography>
              {fotosRumah.length > 0 ? (
                <Stack direction="row" spacing={1} flexWrap="wrap" sx={{ gap: 1 }}>
                  {fotosRumah.map((foto, fi) => (
                    <FileThumbnail key={fi} file={foto.foto_rumah} label={`Foto ${fi + 1}`} fileBase={null} size={80}
                      onPreview={() => openPreview(fotosRumah.map(f => f.foto_rumah), fotosRumah.map((_, i) => `Foto ${i + 1}`), null, 'Foto Rumah Penerima')} />
                  ))}
                </Stack>
              ) : (
                <Box sx={{ width: '100%', maxWidth: 200, height: 100, bgcolor: '#f5f5f5', borderRadius: 2, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <Typography variant="caption" color="text.secondary">Tidak ada foto</Typography>
                </Box>
              )}
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>

      {/* Peta Lokasi */}
      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMore />}>
          <Typography variant="subtitle1" fontWeight={600}>
            <LocationOn sx={{ mr: 1, verticalAlign: 'middle' }} />
            Peta Lokasi
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <MapsBantuan
            latitude={coordinates.lat}
            longitude={coordinates.lng}
            alamat={pemohon?.alamat || bantuan?.alamatLengkap || ''}
            nama={pemohon?.nama || ''}
          />
        </AccordionDetails>
      </Accordion>

      {/* Dokumentasi Pengerjaan */}
      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMore />}>
          <Typography variant="subtitle1" fontWeight={600}>
            <PhotoCamera sx={{ mr: 1, verticalAlign: 'middle' }} />
            Dokumentasi Pengerjaan
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <FotoGallery langkah={langkah} title="Foto Proses Pengerjaan" />
        </AccordionDetails>
      </Accordion>

      {/* Informasi Bantuan */}
      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMore />}>
          <Typography variant="subtitle1" fontWeight={600}>
            <AttachMoney sx={{ mr: 1, verticalAlign: 'middle' }} />
            Informasi Bantuan
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <Typography variant="caption" color="text.secondary">Jenis Bantuan</Typography>
              <Typography variant="body1" fontWeight={500}>{bantuan?.JenisBantuan || '-'}</Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="caption" color="text.secondary">Nominal</Typography>
              <Typography variant="body1" fontWeight={600} color="primary.main">
                {formatRp(bantuan?.nominal)}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="caption" color="text.secondary">Tanggal Bantuan</Typography>
              <Typography variant="body1">{formatDate(bantuan?.tanggalBantuan)}</Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="caption" color="text.secondary">Status Kontrak</Typography>
              <Typography variant="body1">{bantuan?.statusKontrak || '-'}</Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="caption" color="text.secondary">TFL</Typography>
              <Typography variant="body1">{bantuan?.namaTFL || '-'}</Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="caption" color="text.secondary">AGR</Typography>
              <Typography variant="body1">{bantuan?.namaAgr || '-'}</Typography>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>

      {/* Progress Fisik (Tahapan Pengerjaan) */}
      {/* <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMore />}>
          <Typography variant="subtitle1" fontWeight={600}>
            <Engineering sx={{ mr: 1, verticalAlign: 'middle' }} />
            Proses Fisik
            {progressFisik.length > 0 && (
              <Chip size="small" sx={{ ml: 1 }} label={`${progressFisik.filter(l => l.status === 'Selesai').length}/${progressFisik.length}`} variant="outlined" />
            )}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          {rabData ? (
            progressFisik.length > 0 ? (
              <Box>
                <Chip size="small" label={`Tipe: ${progressFisik[0]?.tipe || '-'}`} color="primary" sx={{ mb: 1 }} />
                <Box sx={{ position: 'relative', pl: 2 }}>
                  {progressFisik.map((step, index) => (
                    <Box key={step.id} sx={{ position: 'relative', pb: 3 }}>
                      {index < progressFisik.length - 1 && (
                        <Box sx={{
                          position: 'absolute', left: -5, top: 24, bottom: 0, width: 2,
                          bgcolor: step.status === 'Selesai' ? 'success.main' : '#e0e0e0',
                        }} />
                      )}
                      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
                        <Box sx={{
                          minWidth: 28, height: 28, borderRadius: '50%', display: 'flex',
                          alignItems: 'center', justifyContent: 'center',
                          bgcolor: step.status === 'Selesai' ? 'success.main' :
                                   step.status === 'Sedang Berlangsung' ? 'warning.main' : '#e0e0e0',
                          color: step.status === 'Belum Dimulai' ? 'text.secondary' : 'white',
                          fontSize: 12, fontWeight: 600, zIndex: 1,
                        }}>
                          {step.status === 'Selesai' ? <Check fontSize="inherit" /> : index + 1}
                        </Box>
                        <Box sx={{ flex: 1 }}>
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap' }}>
                            <Typography variant="body2" fontWeight={500}>{labelValidasi(step.tahap)}</Typography>
                            <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
                              <Chip size="small" label={`${step.bobot}%`} variant="outlined" sx={{ fontSize: 11 }} />
                              <Chip size="small" color={statusColor(step.status)} label={labelValidasi(step.status)} />
                            </Box>
                          </Box>
                          {step.foto && (() => {
                            try {
                              const fotos = JSON.parse(step.foto);
                              if (Array.isArray(fotos) && fotos.length > 0) {
                                return (
                                  <Stack direction="row" spacing={0.5} flexWrap="wrap" sx={{ mt: 0.5 }}>
                                    {fotos.map((f, fi) => (
                                      <SecureFileImg key={fi} src={toProtectedFileUrl(`${BASE_URL}/files/rab-progress-fisik/${String(f).split('/').pop()}`)} alt={`foto ${fi + 1}`}
                                        style={{ width: 60, height: 60, objectFit: 'cover', borderRadius: 4, border: '1px solid #ddd', cursor: 'pointer' }}
                                        onClick={() => openInAppFilePreview({ url: toProtectedFileUrl(`${BASE_URL}/files/rab-progress-fisik/${String(f).split('/').pop()}`) })} />
                                    ))}
                                  </Stack>
                                );
                              }
                            } catch (e) {}
                            return null;
                          })()}
                          <Box sx={{ mt: 1 }}>
                            {editStep?.id === step.id && editStep?.type === 'fisik-top' ? (
                              <Stack spacing={1}>
                                <FormControl size="small" sx={{ minWidth: 150 }}>
                                  <InputLabel>Status</InputLabel>
                                  <Select value={editStatus} label="Status" onChange={(e) => setEditStatus(e.target.value)}>
                                    <MenuItem value="Belum Dimulai">Belum Dimulai</MenuItem>
                                    <MenuItem value="Sedang Berlangsung">Sedang Berlangsung</MenuItem>
                                    <MenuItem value="Menunggu Verifikasi">Menunggu Validasi</MenuItem>
                                    <MenuItem value="Selesai">Selesai</MenuItem>
                                  </Select>
                                </FormControl>
                                <Stack direction="row" spacing={1} flexWrap="wrap">
                                  <Button component="label" size="small" variant="outlined" startIcon={<CloudUpload />}>
                                    Foto {editFoto ? `(${editFoto.length || editFoto.name || 'dipilih'})` : ''}
                                    <input type="file" hidden multiple accept="image/*" onChange={(e) => setEditFoto(e.target.files)} />
                                  </Button>
                                </Stack>
                                <Stack direction="row" spacing={1}>
                                  <Button size="small" variant="contained" color="success" onClick={() => handleUpdateProgress(step.id, 'fisik')}>Simpan</Button>
                                  <Button size="small" variant="text" onClick={() => setEditStep(null)}>Batal</Button>
                                </Stack>
                              </Stack>
                            ) : canUpload ? (
                              <Button size="small" variant="text" sx={{ mt: 0.5 }} onClick={() => openEdit(step, 'fisik')}>
                                <PhotoCamera fontSize="small" sx={{ mr: 0.5 }} /> Kelola
                              </Button>
                            ) : null}
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  ))}
                </Box>
              </Box>
            ) : (
              <Stack spacing={1.5}>
                <Typography variant="body2" color="text.secondary">Progress fisik belum dibuat.</Typography>
                <Stack direction="row" spacing={1}>
                  {canUpload && (
                    <>
                  <Button size="small" variant="contained" color="success" startIcon={<HomeWork />} onClick={handleInitPembangunan}>
                    Inisialisasi Pembangunan
                  </Button>
                  <Button size="small" variant="outlined" color="primary" onClick={handleInitRehabilitasi}>
                    Inisialisasi Rehabilitasi
                  </Button>
                    </>
                  )}
                </Stack>
                {bantuan?.JenisBantuan && (
                  <Typography variant="caption" color="text.secondary">Jenis bantuan: {bantuan.JenisBantuan}</Typography>
                )}
              </Stack>
            )
          ) : (
            <Typography variant="body2" color="text.secondary">Buat RAB terlebih dahulu untuk melihat progres fisik.</Typography>
          )}
        </AccordionDetails>
      </Accordion> */}

      {/* ============================================================
          UPAH TUKANG & FOTO KWITANSI
          ============================================================ */}
      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMore />}>
          <Typography variant="subtitle1" fontWeight={600}>
            <Receipt sx={{ mr: 1, verticalAlign: 'middle' }} />
            Upah Tukang & Foto Kwitansi
            {upahtukang && upahtukang.length > 0 && (
              <Chip size="small" label={`${upahtukang.length} data`} variant="outlined" sx={{ ml: 1 }} />
            )}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          {upahtukang && upahtukang.length > 0 ? (
            <Stack spacing={2}>
              {upahWithFoto.map((upah, index) => (
                <Paper key={upah.id} sx={{ p: 2, bgcolor: '#f8f9fa', borderRadius: 2 }}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 1 }}>
                    <Box>
                      <Typography variant="subtitle2" fontWeight={600}>
                        Upah Tukang #{index + 1}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        Dibuat: {formatDate(upah.createdAt)}
                      </Typography>
                    </Box>
                    <Chip 
                      label={formatRp(upah.totalUpah)} 
                      color="primary" 
                      size="small"
                      sx={{ fontWeight: 600 }}
                    />
                  </Box>
                  
<Divider sx={{ my: 1.5 }} />
                   
                   <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
                     <Typography variant="caption" color="text.secondary">Tahap:</Typography>
                     <Chip size="small" label={upah.tahap === 'tahap_1' ? 'Tahap I (30-50%)' : 'Tahap II (100%)'}
                       color={upah.tahap === 'tahap_1' ? 'warning' : 'success'} variant="outlined" />
                   </Stack>
                   
                   <Typography variant="body2" fontWeight={500} color="primary.main">
                     Nominal: {formatRp(upah.totalUpah)}
                   </Typography>
                  
                  {upah.keterangan && (
                    <Box sx={{ mt: 1 }}>
                      <Typography variant="caption" color="text.secondary">Keterangan</Typography>
                      <Typography variant="body2">{upah.keterangan}</Typography>
                    </Box>
                  )}
                  
                  {/* Foto Kwitansi */}
                  {upah.fotoList && upah.fotoList.length > 0 && (
                    <Box sx={{ mt: 2 }}>
                      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1 }}>
                        Foto Kwitansi ({upah.fotoList.length})
                      </Typography>
                      <Stack direction="row" spacing={1} flexWrap="wrap">
                        {upah.fotoList.map((foto) => (
                          <Box key={foto.id} sx={{ position: 'relative' }}>
<SecureFileImg
                              src={`${BASE_URL}/files/kwitansi-upah/${foto.foto_kwitansi}`}
                              alt="Kwitansi"
                              style={{
                                width: 120,
                                height: 120,
                                objectFit: 'cover',
                                borderRadius: 8,
                                border: '1px solid #e0e0e0'
                              }}
                              onError={(e) => {
                                e.target.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 24 24"%3E%3Cpath fill="%23ccc" d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM7 10h2v7H7zm4-3h2v10h-2zm4 6h2v4h-2z"/%3E%3C/svg%3E';
                              }}
                            />
                            <IconButton
                              size="small"
                              sx={{
                                position: 'absolute',
                                top: 4,
                                right: 4,
                                bgcolor: 'rgba(255,255,255,0.8)',
                                '&:hover': { bgcolor: 'white' }
                              }}
                              onClick={() => openInAppFilePreview({ url: toProtectedFileUrl(`${BASE_URL}/files/kwitansi-upah/${foto.foto_kwitansi}`) })}
                            >
                              <Visibility fontSize="small" />
                            </IconButton>
                          </Box>
                        ))}
                      </Stack>
                    </Box>
                  )}
                </Paper>
              ))}
              
              {/* Total Keseluruhan */}
              <Paper sx={{ p: 2, bgcolor: '#e3f2fd', borderRadius: 2 }}>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                  <Typography variant="subtitle2" fontWeight={600}>
                    Total Keseluruhan Upah Tukang
                  </Typography>
                  <Typography variant="h6" fontWeight={700} color="primary.main">
                    {formatRp(upahtukang.reduce((sum, u) => sum + Number(u.totalUpah), 0))}
                  </Typography>
                </Stack>
              </Paper>
            </Stack>
          ) : (
            <Typography variant="body2" color="text.secondary">Belum ada data upah tukang</Typography>
          )}
        </AccordionDetails>
      </Accordion>

      {/* Pembelian Supplier */}
      {pembelianSupplier?.riwayatPembelianSupplier?.length > 0 && (
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMore />}>
            <Typography variant="subtitle1" fontWeight={600}>
              <Store sx={{ mr: 1, verticalAlign: 'middle' }} />
              Pembelian Supplier
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            {pembelianSupplier.riwayatPembelianSupplier.map((pembelian) => (
              <Card key={pembelian.id} sx={{ mb: 2, bgcolor: '#f8f9fa' }}>
                <CardContent>
                  <Typography variant="subtitle2" fontWeight={600}>
                    {pembelian.SupplierBarang?.namaSupplier || 'Supplier'}
                  </Typography>
                  <Typography variant="body2" color="primary" fontWeight={600}>
                    Total: {formatRp(pembelian.totalTransaksi)}
                  </Typography>
                  
                  <TableContainer component={Paper} sx={{ mt: 1 }}>
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell>Nama Barang</TableCell>
                          <TableCell align="right">Harga</TableCell>
                          <TableCell align="right">Jumlah</TableCell>
                          <TableCell align="right">Total</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {pembelian.DetailTransaksi?.map((item) => (
                          <TableRow key={item.id}>
                            <TableCell>{item.namaBarang}</TableCell>
                            <TableCell align="right">{formatRp(item.hargaSatuan)}</TableCell>
                            <TableCell align="right">{item.jumlahBarang}</TableCell>
                            <TableCell align="right">{formatRp(item.totalTransaksi)}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </CardContent>
              </Card>
            ))}
          </AccordionDetails>
        </Accordion>
      )}
      {/* ============================================================
          RAB & PROGRESS ADMINISTRASI & PROGRESS KEUANGAN & PROGRESS FISIK
      ============================================================ */}
      {rabLoading ? (
        <Box sx={{ textAlign: 'center', py: 3 }}>
          <CircularProgress size={24} />
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>Memuat RAB...</Typography>
        </Box>
      ) : (
        <>
          {/* RAB */}
          <Accordion defaultExpanded={!!rabData}>
            <AccordionSummary expandIcon={<ExpandMore />}>
              <Typography variant="subtitle1" fontWeight={600}>
                <Payments sx={{ mr: 1, verticalAlign: 'middle' }} />
                RAB (Rencana Anggaran Biaya)
                {rabData && (
                  <Chip
                    size="small"
                    sx={{ ml: 1 }}
                    color={rabData.status === 'disetujui' ? 'success' : rabData.status === 'diajukan' ? 'warning' : 'default'}
                    label={rabData.status || '-'}
                  />
                )}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              {rabData ? (
                <Stack spacing={2}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                      <Typography variant="caption" color="text.secondary">Keterangan</Typography>
                      <Typography variant="body2">{rabData.keterangan || '-'}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography variant="caption" color="text.secondary">Total Harga</Typography>
                      <Typography variant="body2" fontWeight={600}>{formatRp(rabData.totalHarga)}</Typography>
                    </Grid>
                  </Grid>

                  {rabData.SupplierToko && rabData.SupplierToko.length > 0 && (
                    <Box>
                      <Typography variant="caption" color="text.secondary">Toko Supplier ({rabData.SupplierToko.length})</Typography>
                      <Stack direction="row" spacing={0.5} flexWrap="wrap" sx={{ mt: 0.5 }}>
                        {rabData.SupplierToko.map((st) => (
                          <Chip
                            key={st.id}
                            size="small"
                            variant="outlined"
                            label={st.SupplierBarang?.namaToko || st.SupplierBarang?.namaSupplier || `Toko #${st.SupplierBarangId}`}
                          />
                        ))}
                      </Stack>
                    </Box>
                  )}

                  {rabData.SupplierBarang && (
                    <Box>
                      <Typography variant="caption" color="text.secondary">Supplier Utama</Typography>
                      <Typography variant="body2">{rabData.SupplierBarang.namaToko || rabData.SupplierBarang.namaSupplier || '-'}</Typography>
                    </Box>
                  )}

                  {rabData.fileRab && (
                    <Box>
                      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1 }}>Berkas RAB</Typography>
                      <Button
                        size="small"
                        variant="outlined"
                        startIcon={<Visibility />}
                        onClick={() => openInAppFilePreview({ url: `${BASE_URL}/rab/file/${rabData.fileRab.replace('rab/', '')}` })}
                      >
                        Lihat Berkas
                      </Button>
                    </Box>
                  )}

                  {rabData.TFL && (
                    <Box>
                      <Typography variant="caption" color="text.secondary">Diinput oleh</Typography>
                      <Typography variant="body2">{rabData.TFL.username} {rabData.TFL.NoWa ? `(${rabData.TFL.NoWa})` : ''}</Typography>
                    </Box>
                  )}
                </Stack>
                ) : canUpload ? (
                  <Box>
                    <Alert severity="info" sx={{ mb: 2 }}>
                      RAB belum dibuat. Progress tetap berjalan berdasarkan BantuanId. Upload RAB hanya untuk melengkapi dokumen perencanaan.
                    </Alert>
                  <Stack spacing={2}>
                    <TextField
                      label="Keterangan RAB"
                      value={rabKeterangan}
                      onChange={(e) => setRabKeterangan(e.target.value)}
                      multiline rows={2}
                      size="small"
                      fullWidth
                      placeholder="Contoh: RAB Pembangunan Rumah Layak Huni"
                    />
                    <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
                      <Button component="label" variant="outlined" size="small" startIcon={<CloudUpload />}>
                        {rabFile ? rabFile.name : 'Pilih File RAB (PDF)'}
                        <input type="file" hidden accept=".pdf,application/pdf" onChange={(e) => setRabFile(e.target.files[0])} />
                      </Button>
                      <Chip size="small" label="Wajib PDF" variant="outlined" />
                    </Stack>
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      disabled={rabSaving || !rabFile}
                      onClick={handleCreateRab}
                      startIcon={rabSaving ? <CircularProgress size={14} /> : <CloudUpload />}
                    >
                      {rabSaving ? 'Menyimpan...' : 'Buat RAB'}
                    </Button>
                  </Stack>
                </Box>
                ) : (
                  <Typography variant="body2" color="text.secondary">RAB belum dibuat.</Typography>
                )}
            </AccordionDetails>
          </Accordion>

          {/* Progress Administrasi */}
          {(rabData || admBantuan || (langkah && langkah.length > 0)) && (
            <Accordion defaultExpanded>
              <AccordionSummary expandIcon={<ExpandMore />}>
                <Typography variant="subtitle1" fontWeight={600}>
                  <Receipt sx={{ mr: 1, verticalAlign: 'middle' }} />
                  A. Progress Administrasi
                  <Chip size="small" sx={{ ml: 1 }} label={`${pctAdm.presentase}%`} color={pctAdm.presentase >= 100 ? 'success' : 'default'} />
                  {(mergedAdministrasi.length > 0 || (langkah && langkah.length > 0)) && (
                    <Chip
                      size="small"
                      sx={{ ml: 0.5 }}
                      label={`${mergedAdministrasi.length > 0 ? mergedAdministrasi.filter(l => l.status === 'Selesai' || l.dokumen || l.foto).length : (langkah || []).filter(l => l.status === 'Selesai').length}/${mergedAdministrasi.length > 0 ? mergedAdministrasi.length : (langkah || []).length}`}
                      variant="outlined"
                    />
                  )}
                </Typography>
              </AccordionSummary>
             <AccordionDetails>
                {(() => {
                  const displaySteps = mergedAdministrasi.length > 0 ? mergedAdministrasi
                    : (langkah && langkah.length > 0 ? langkah.map(l => ({ ...l })) : []);
                  if (displaySteps.length === 0) {
                    return (
                      <Stack spacing={1.5}>
                        <Typography variant="body2" color="text.secondary">Progress administrasi belum dibuat.</Typography>
                        {canUpload && rabData && (
                          <Button
                            size="small"
                            variant="contained"
                            color="primary"
                            startIcon={<CheckCircle />}
                            onClick={handleInitAdministrasi}
                          >
                            Inisialisasi Progress Administrasi
                          </Button>
                        )}
                      </Stack>
                    );
                  }
                  return (
                    <Box sx={{ position: 'relative', pl: 2 }}>
                      {displaySteps.map((step, index) => {
                        const fileBase = step.fileBase || null;
                        return (
                          <Box key={step.id} sx={{ position: 'relative', pb: 3 }}>
                            {index < displaySteps.length - 1 && (
                              <Box sx={{
                                position: 'absolute', left: -5, top: 24, bottom: 0, width: 2,
                                bgcolor: step.status === 'Selesai' ? 'success.main' : '#e0e0e0',
                              }} />
                            )}
                            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
                              <Box sx={{
                                minWidth: 28, height: 28, borderRadius: '50%', display: 'flex',
                                alignItems: 'center', justifyContent: 'center',
                                bgcolor: step.status === 'Selesai' ? 'success.main' :
                                         step.status === 'Sedang Berlangsung' ? 'warning.main' : '#e0e0e0',
                                color: step.status === 'Belum Dimulai' ? 'text.secondary' : 'white',
                                fontSize: 12, fontWeight: 600, zIndex: 1,
                              }}>
                                {step.status === 'Selesai' ? <Check fontSize="inherit" /> : index + 1}
                              </Box>
                              <Box sx={{ flex: 1 }}>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap' }}>
                                  <Typography variant="body2" fontWeight={500}>{labelValidasi(step.tahap)}</Typography>
                                  <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
                                    <Chip size="small" label={`${step.bobot || 0}%`} variant="outlined" sx={{ fontSize: 11 }} />
                                    <Chip size="small" color={statusColor(step.status)} label={labelValidasi(step.status)} />
                                  </Box>
                                </Box>
                                {step.foto && (() => {
                                  try {
                                    const fotos = JSON.parse(step.foto);
                                    if (Array.isArray(fotos) && fotos.length > 0) {
                                      const fotoLabels = getFotoLabels('administrasi', step, fotos, bantuan?.JenisBantuan);
                                      return (
                                        <Stack direction="row" spacing={0.5} flexWrap="wrap" sx={{ mt: 0.5, gap: 0.5 }}>
                                          {fotos.map((f, fi) => (
                                            <FileThumbnail key={fi} file={f} label={fotoLabels[fi]} fileBase={fileBase} size={60}
                                              onPreview={() => openPreview(fotos, fotoLabels, fileBase, step.tahap)} />
                                          ))}
                                        </Stack>
                                      );
                                    }
                                  } catch (e) {}
                                  return null;
                                })()}
                                {step.dokumen && (() => {
                                  try {
                                    const docs = JSON.parse(step.dokumen);
                                    if (Array.isArray(docs) && docs.length > 0) {
                                      const labels = getDocumentLabels('administrasi', step, docs);
                                      return (
                                        <Stack direction="row" spacing={0.5} flexWrap="wrap" sx={{ mt: 0.5, gap: 0.5 }}>
                                          {docs.map((d, di) => (
                                            <FileThumbnail key={di} file={d} label={labels[di]} fileBase={fileBase}
                                              onPreview={() => openPreview(docs, labels, fileBase, step.tahap)} />
                                          ))}
                                        </Stack>
                                      );
                                    }
                                  } catch (e) {}
                                  return null;
                                })()}
                                <Box sx={{ mt: 1 }}>
                                  {canUpload && !step.readOnly && (
                                    editStep?.id === step.id && editStep?.type === 'administrasi' ? (
                                      <StepUploadForm step={step} type="administrasi" jenisBantuan={bantuan?.JenisBantuan}
                                        onSave={(formData) => handleStepSave(step.id, 'administrasi', formData)}
                                        onCancel={() => setEditStep(null)} />
                                    ) : (
                                      <Button size="small" variant="text" sx={{ mt: 0.5 }} onClick={() => setEditStep({ id: step.id, type: 'administrasi' })}>
                                        <PhotoCamera fontSize="small" sx={{ mr: 0.5 }} /> Kelola
                                      </Button>
                                    )
                                  )}
                                </Box>
                              </Box>
                            </Box>
                          </Box>
                        );
                      })}
                    </Box>
                  );
                })()}
              </AccordionDetails>
            </Accordion>
          )}

          {/* Progress Keuangan */}
            <Accordion>
              <AccordionSummary expandIcon={<ExpandMore />}>
                <Typography variant="subtitle1" fontWeight={600}>
                  <Receipt sx={{ mr: 1, verticalAlign: 'middle' }} />
                  B. Progress Keuangan
                  {progressKeuangan.length > 0 && (
                    <Chip
                      size="small"
                      sx={{ ml: 1 }}
                      label={`${progressKeuangan.filter(l => l.status === 'Selesai').length}/${progressKeuangan.length}`}
                      variant="outlined"
                    />
                  )}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Alert severity="info" sx={{ mb: 2, py: 0.5 }}>
                  <Typography variant="caption">Step 1 (Dana Diterima) terintegrasi otomatis dari dokumen Administrasi. Droping = foto + nota. Pembayaran Supplier = bukti transfer. Upah = Form Pengambilan Upah.</Typography>
                </Alert>
                {progressKeuangan.length > 0 ? (
                  <Box sx={{ position: 'relative', pl: 2 }}>
                    {progressKeuangan.map((step, index) => (
                      <Box key={step.id} sx={{ position: 'relative', pb: 3 }}>
                        {index < progressKeuangan.length - 1 && (
                          <Box sx={{
                            position: 'absolute', left: -5, top: 24, bottom: 0, width: 2,
                            bgcolor: step.status === 'Selesai' ? 'success.main' : '#e0e0e0',
                          }} />
                        )}
                        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
                          <Box sx={{
                            minWidth: 28, height: 28, borderRadius: '50%', display: 'flex',
                            alignItems: 'center', justifyContent: 'center',
                            bgcolor: step.status === 'Selesai' ? 'success.main' :
                                     step.status === 'Sedang Berlangsung' ? 'warning.main' : '#e0e0e0',
                            color: step.status === 'Belum Dimulai' ? 'text.secondary' : 'white',
                            fontSize: 12, fontWeight: 600, zIndex: 1,
                          }}>
                            {step.status === 'Selesai' ? <Check fontSize="inherit" /> : index + 1}
                          </Box>
                          <Box sx={{ flex: 1 }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap' }}>
                              <Typography variant="body2" fontWeight={500}>{labelValidasi(step.tahap)}</Typography>
                              <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
                                <Chip size="small" label={`${step.bobot}%`} variant="outlined" sx={{ fontSize: 11 }} />
                                <Chip size="small" color={statusColor(step.status)} label={labelValidasi(step.status)} />
                              </Box>
                            </Box>
                            {step.foto && (
                              <Box sx={{ mt: 0.5 }}>
                                <FileThumbnail file={step.foto} label="Foto Droping Material" fileBase="rab-progress" size={80}
                                  onPreview={() => openPreview(step.foto, 'Foto Droping Material', 'rab-progress', step.tahap)} />
                              </Box>
                            )}
                            {step.dokumen && (() => {
                              try {
                                const docs = JSON.parse(step.dokumen);
                                if (Array.isArray(docs) && docs.length > 0) {
                                  const labels = getDocumentLabels('keuangan', step, docs);
                                  return (
                                    <Stack direction="row" spacing={0.5} flexWrap="wrap" sx={{ mt: 0.5, gap: 0.5 }}>
                                      {docs.map((d, di) => (
                                        <FileThumbnail key={di} file={d} label={labels[di]} fileBase="rab-progress"
                                          onPreview={() => openPreview(docs, labels, 'rab-progress', step.tahap)} />
                                      ))}
                                    </Stack>
                                  );
                                }
                              } catch (e) {}
                              return null;
                            })()}
                            <Box sx={{ mt: 1 }}>
                              {editStep?.id === step.id && editStep?.type === 'keuangan' ? (
                                <StepUploadForm step={step} type="keuangan" jenisBantuan={bantuan?.JenisBantuan} saveButtonColor="warning"
                                  onSave={(formData) => handleStepSave(step.id, 'keuangan', formData)}
                                  onCancel={() => setEditStep(null)} />
                              ) : canUpload ? (
                                <Button size="small" variant="text" sx={{ mt: 0.5 }} onClick={() => setEditStep({ id: step.id, type: 'keuangan' })}>
                                  <PhotoCamera fontSize="small" sx={{ mr: 0.5 }} /> Kelola
                                </Button>
                              ) : null}
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    ))}
                  </Box>
                ) : (
                  <Typography variant="body2" color="text.secondary">Belum ada progress keuangan</Typography>
                )}
              </AccordionDetails>
            </Accordion>

          {/* Progress Fisik */}
            <Accordion>
              <AccordionSummary expandIcon={<ExpandMore />}>
                <Typography variant="subtitle1" fontWeight={600}>
                  <Engineering sx={{ mr: 1, verticalAlign: 'middle' }} />
                  C/D. Progress Fisik
                  {progressFisik.length > 0 && (
                    <Chip
                      size="small"
                      sx={{ ml: 1 }}
                      label={`${progressFisik.filter(l => l.status === 'Selesai').length}/${progressFisik.length}`}
                      variant="outlined"
                    />
                  )}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                {progressFisik.length > 0 ? (
                  <Box>
                    <Chip size="small" label={`Tipe: ${progressFisik[0]?.tipe || '-'}`} color="primary" sx={{ mb: 1 }} />
                    <Box sx={{ position: 'relative', pl: 2 }}>
                      {progressFisik.map((step, index) => (
                        <Box key={step.id} sx={{ position: 'relative', pb: 3 }}>
                          {index < progressFisik.length - 1 && (
                            <Box sx={{
                              position: 'absolute', left: -5, top: 24, bottom: 0, width: 2,
                              bgcolor: step.status === 'Selesai' ? 'success.main' : '#e0e0e0',
                            }} />
                          )}
                          <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
                            <Box sx={{
                              minWidth: 28, height: 28, borderRadius: '50%', display: 'flex',
                              alignItems: 'center', justifyContent: 'center',
                              bgcolor: step.status === 'Selesai' ? 'success.main' :
                                       step.status === 'Sedang Berlangsung' ? 'warning.main' : '#e0e0e0',
                              color: step.status === 'Belum Dimulai' ? 'text.secondary' : 'white',
                              fontSize: 12, fontWeight: 600, zIndex: 1,
                            }}>
                              {step.status === 'Selesai' ? <Check fontSize="inherit" /> : index + 1}
                            </Box>
                            <Box sx={{ flex: 1 }}>
                              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap' }}>
                                <Typography variant="body2" fontWeight={500}>{labelValidasi(step.tahap)}</Typography>
                                <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
                                  <Chip size="small" label={`${step.bobot}%`} variant="outlined" sx={{ fontSize: 11 }} />
                                  <Chip size="small" color={statusColor(step.status)} label={labelValidasi(step.status)} />
                                </Box>
                              </Box>
                              {step.foto && (() => {
                                try {
                                  const fotos = JSON.parse(step.foto);
                                  if (Array.isArray(fotos) && fotos.length > 0) {
                                    const fotoLabels = getFotoLabels('fisik', step, fotos, bantuan?.JenisBantuan);
                                    return (
                                      <Stack direction="row" spacing={0.5} flexWrap="wrap" sx={{ mt: 0.5, gap: 0.5 }}>
                                        {fotos.map((f, fi) => (
                                          <FileThumbnail key={fi} file={f} label={fotoLabels[fi]} fileBase="rab-progress-fisik" size={60}
                                            onPreview={() => openPreview(fotos, fotoLabels, 'rab-progress-fisik', step.tahap)} />
                                        ))}
                                      </Stack>
                                    );
                                  }
                                } catch (e) {}
                                return null;
                            })()}
                            <Box sx={{ mt: 1 }}>
                              {editStep?.id === step.id && editStep?.type === 'fisik' ? (
                                <StepUploadForm step={step} type="fisik" jenisBantuan={bantuan?.JenisBantuan}
                                  onSave={(formData) => handleStepSave(step.id, 'fisik', formData)}
                                  onCancel={() => setEditStep(null)} />
                              ) : canUpload ? (
                                <Button size="small" variant="text" sx={{ mt: 0.5 }} onClick={() => setEditStep({ id: step.id, type: 'fisik' })}>
                                  <PhotoCamera fontSize="small" sx={{ mr: 0.5 }} /> Kelola
                                </Button>
                              ) : null}
                            </Box>
                            </Box>
                          </Box>
                        </Box>
                      ))}
                    </Box>
                  </Box>
                ) : (
                  <Stack spacing={1.5}>
                    <Typography variant="body2" color="text.secondary">Progress fisik belum dibuat.</Typography>
                    <Stack direction="row" spacing={1}>
                      {canUpload && (
                        <>
                          {!/rehab/i.test(bantuan?.JenisBantuan || '') && (
                            <Button
                              size="small"
                              variant="contained"
                              color="success"
                              startIcon={<HomeWork />}
                              onClick={handleInitPembangunan}
                            >
                              Inisialisasi Pembangunan
                            </Button>
                          )}
                          <Button
                            size="small"
                            variant="outlined"
                            color="primary"
                            onClick={handleInitRehabilitasi}
                          >
                            Inisialisasi Rehabilitasi
                          </Button>
                        </>
                      )}
                    </Stack>
                    {bantuan?.JenisBantuan && (
                      <Typography variant="caption" color="text.secondary">
                        Jenis bantuan: {bantuan.JenisBantuan}
                      </Typography>
                    )}
                  </Stack>
                )}
              </AccordionDetails>
            </Accordion>
          
        </>
      )}

      <FilePreviewModal
        open={preview.open}
        onClose={() => setPreview((p) => ({ ...p, open: false }))}
        files={preview.files}
        labels={preview.labels}
        fileBase={preview.fileBase}
        title={preview.title}
      />
    </Box>
  );
};
// ============================================================
// KOMPONEN STAT CARD
// ============================================================
const StatCard = ({ icon, label, value, color }) => (
  <Card elevation={2} sx={{ height: '100%' }}>
    <CardContent>
      <Stack direction="row" spacing={2} alignItems="center">
        <Box sx={{ 
          bgcolor: `${color}.light`, 
          color: `${color}.main`, 
          borderRadius: 2, 
          p: 1.2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          {icon}
        </Box>
        <Box>
          <Typography variant="caption" color="text.secondary">{label}</Typography>
          <Typography variant="h5" fontWeight={700}>{value}</Typography>
        </Box>
      </Stack>
    </CardContent>
  </Card>
);

// ============================================================
// KOMPONEN FILTER - DENGAN DYNAMIC DESA OPTIONS
// ============================================================
const FilterBar = ({ 
  filters, 
  onChange, 
  onReset, 
  isMobile, 
  filterCount 
}) => {
  const [showFilters, setShowFilters] = useState(!isMobile);
  
  // State untuk desa options berdasarkan kecamatan yang dipilih
  const [desaOptions, setDesaOptions] = useState(DESA_KELURAHAN);

  const handleChange = (key, value) => {
    // Jika kecamatan berubah, update desa options
    if (key === 'kecamatan') {
      const desas = getDesaByKecamatan(value);
      setDesaOptions(desas.length > 0 ? desas : DESA_KELURAHAN);
      
      // Reset desaKelurahan jika kecamatan berubah
      onChange({ 
        ...filters, 
        [key]: value, 
        desaKelurahan: '',
        page: 1 
      });
    } else {
      onChange({ ...filters, [key]: value, page: 1 });
    }
  };

  const filterFields = [
    { 
      key: 'search', 
      label: 'Cari pemohon...', 
      type: 'text', 
      placeholder: 'Cari nama pemohon...', 
      icon: <Search />, 
      xs: 12, sm: 6, md: 4 
    },
    { 
      key: 'statusFilter', 
      label: 'Status', 
      type: 'select', 
      options: ['', ...STATUS_PROSES], 
      xs: 12, sm: 6, md: 4 
    },
    { 
      key: 'jenisBantuan', 
      label: 'Jenis Bantuan', 
      type: 'select', 
      options: ['', ...JENIS_BANTUAN], 
      xs: 12, sm: 6, md: 4 
    },
    { 
      key: 'kecamatan', 
      label: 'Kecamatan', 
      type: 'select', 
      options: ['', ...KECAMATAN], 
      xs: 12, sm: 6, md: 4 
    },
    { 
      key: 'desaKelurahan', 
      label: 'Kelurahan/Desa', 
      type: 'select', 
      options: ['', ...desaOptions], 
      xs: 12, sm: 6, md: 4 
    },
  ];

  return (
    <Paper sx={{ mb: 2, p: { xs: 1.5, sm: 2 } }}>
      {/* Header Filter */}
      <Box sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'space-between', 
        mb: showFilters ? 2 : 0,
        flexWrap: 'wrap',
        gap: 1
      }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Badge badgeContent={filterCount} color="primary" invisible={filterCount === 0}>
            <FilterList color="action" />
          </Badge>
          <Typography variant="subtitle2" fontWeight={600}>
            Filter
          </Typography>
          {filterCount > 0 && (
            <Chip 
              label={`${filterCount} filter aktif`} 
              size="small" 
              color="primary" 
              variant="outlined"
            />
          )}
        </Box>
        
        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
          {filterCount > 0 && (
            <Button 
              size="small" 
              onClick={onReset} 
              startIcon={<Clear />}
              variant="text"
              color="error"
            >
              Reset
            </Button>
          )}
          {isMobile && (
            <Button 
              size="small" 
              onClick={() => setShowFilters(!showFilters)}
              variant="outlined"
            >
              {showFilters ? 'Sembunyikan Filter' : 'Tampilkan Filter'}
            </Button>
          )}
        </Box>
      </Box>

      {/* Filter Fields */}
      <Collapse in={showFilters}>
        <Divider sx={{ mb: 2 }} />
        <Grid container spacing={2}>
          {filterFields.map((field) => (
            <Grid item xs={field.xs || 12} sm={field.sm || 6} md={field.md || 4} key={field.key}>
              {field.type === 'text' ? (
                <TextField
                  fullWidth
                  size="small"
                  placeholder={field.placeholder}
                  value={filters[field.key]}
                  onChange={(e) => handleChange(field.key, e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        {field.icon}
                      </InputAdornment>
                    ),
                    endAdornment: filters[field.key] && (
                      <InputAdornment position="end">
                        <IconButton size="small" onClick={() => handleChange(field.key, '')}>
                          <Clear fontSize="small" />
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                />
              ) : (
                <TextField
                  select
                  fullWidth
                  size="small"
                  label={field.label}
                  value={filters[field.key] || ''}
                  onChange={(e) => handleChange(field.key, e.target.value)}
                  SelectProps={{
                    displayEmpty: false,
                    renderValue: (selected) => {
                      if (!selected) return <em style={{ color: '#999' }}>Semua</em>;
                      return selected;
                    }
                  }}
                >
                  <MenuItem value="">Semua</MenuItem>
                  {field.options.filter(opt => opt !== '').map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </TextField>
              )}
            </Grid>
          ))}
        </Grid>
      </Collapse>
    </Paper>
  );
};

// ============================================================
// KOMPONEN TABLE ROW
// ============================================================
const MonitoringRow = ({ row, index, page, limit, onViewDetail }) => {
  const isMobile = useMediaQuery('(max-width:600px)');

  const data = {
    id: row.id || row.bantuan?.id,
    nama: row.pemohon?.nama || row.bantuan?.pemohon?.nama || '-',
    kecamatan: row.pemohon?.kecamatan || '-',
    desa: row.pemohon?.desaKelurahan || '-',
    jenisBantuan: row.JenisBantuan || row.bantuan?.JenisBantuan || '-',
    nominal: row.nominal || row.bantuan?.nominal,
    presentase: row.Presentase?.presentase ?? row.bantuan?.Presentase?.presentase ?? 0,
    status: row.ProsesBantuan?.statusProses || row.bantuan?.ProsesBantuan?.statusProses || '-',
  };

  if (isMobile) {
    return (
      <Card sx={{ mb: 1.5, p: 1.5 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
          <Box sx={{ flex: 1 }}>
            <Typography variant="subtitle2" fontWeight={600}>{data.nama}</Typography>
            <Typography variant="caption" color="text.secondary" display="block">
              {data.jenisBantuan} • {formatRp(data.nominal)}
            </Typography>
            <Box sx={{ display: 'flex', gap: 0.5, mt: 0.5, flexWrap: 'wrap' }}>
              <Chip size="small" label={data.kecamatan} variant="outlined" />
              <Chip size="small" label={data.desa} variant="outlined" />
            </Box>
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 0.5 }}>
            <Chip 
              size="small" 
              color={statusColor(data.status)} 
              label={data.status} 
            />
            <Button 
              size="small" 
              variant="outlined" 
              startIcon={<Visibility />}
              onClick={() => onViewDetail(data.id)}
              sx={{ mt: 0.5 }}
            >
              Detail
            </Button>
          </Box>
        </Box>
        <Box sx={{ mt: 1 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography variant="caption">Progress</Typography>
            <Typography variant="caption" fontWeight={600}>{data.presentase}%</Typography>
          </Box>
          <LinearProgress 
            variant="determinate" 
            value={data.presentase} 
            sx={{ height: 4, borderRadius: 2 }} 
          />
        </Box>
      </Card>
    );
  }

  return (
    <tr style={{ borderBottom: '1px solid #f0f0f0' }}>
      <td style={{ padding: '10px' }}>{(page - 1) * limit + index + 1}</td>
      <td style={{ padding: '10px', fontWeight: 600 }}>{data.nama}</td>
      <td style={{ padding: '10px' }}>{data.kecamatan}</td>
      <td style={{ padding: '10px' }}>{data.desa}</td>
      <td style={{ padding: '10px' }}>{data.jenisBantuan}</td>
      <td style={{ padding: '10px' }}>{formatRp(data.nominal)}</td>
      <td style={{ padding: '10px', minWidth: 140 }}>
        <Typography variant="caption">{data.presentase}%</Typography>
        <LinearProgress 
          variant="determinate" 
          value={data.presentase} 
          sx={{ height: 6, borderRadius: 3 }} 
        />
      </td>
      <td style={{ padding: '10px' }}>
        <Chip size="small" color={statusColor(data.status)} label={data.status} />
      </td>
      <td style={{ padding: '10px' }}>
        <Tooltip title="Lihat Detail">
          <IconButton 
            size="small" 
            color="primary"
            onClick={() => onViewDetail(data.id)}
          >
            <Visibility />
          </IconButton>
        </Tooltip>
      </td>
    </tr>
  );
};

// ============================================================
// KOMPONEN UTAMA
// ============================================================
const MonitoringBantuan = () => {
  const navigate = useNavigate();
  // State
  const [stats, setStats] = useState(null);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [detailOpen, setDetailOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [filters, setFilters] = useState({
    search: '',
    statusFilter: '',
    kecamatan: '',
    desaKelurahan: '',
    jenisBantuan: ''
  });
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  const isMobile = useMediaQuery('(max-width:800px)');

  // Helper
  const notify = (message, severity = 'success') =>
    setSnackbar({ open: true, message, severity });

  const filterCount = Object.values(filters).filter(v => v !== '').length;

  // Fetch Stats
  const fetchStats = useCallback(async () => {
    try {
      const res = await getDashboardStats();
      setStats(res.data);
    } catch (err) {
      console.error(err);
    }
  }, []);

  // Fetch List
  const fetchList = useCallback(async () => {
    setLoading(true);
    try {
      const res = await getBantuan({
        page,
        limit,
        searchName: filters.search,
        statusProses: filters.statusFilter,
        kecamatan: filters.kecamatan,
        desaKelurahan: filters.desaKelurahan,
        JenisBantuan: filters.jenisBantuan
      });
      setRows(res.data.data || []);
      setTotalItems(res.data.totalItems ?? res.data.pagination?.totalItems ?? 0);
      setTotalPages(res.data.totalPages ?? res.data.pagination?.totalPages ?? 1);
    } catch (err) {
      console.error(err);
      notify('Gagal mengambil data monitoring', 'error');
    } finally {
      setLoading(false);
    }
  }, [page, limit, filters]);

  // Reset Filters
  const resetFilters = () => {
    setFilters({
      search: '',
      statusFilter: '',
      kecamatan: '',
      desaKelurahan: '',
      jenisBantuan: ''
    });
    setPage(1);
  };

  // View Detail
  const handleViewDetail = (id) => {
    navigate(`/monitoring-bantuan/${id}`);
  };

  // Effects
  useEffect(() => {
    fetchStats();
  }, [fetchStats]);

  useEffect(() => {
    const t = setTimeout(() => fetchList(), 400);
    return () => clearTimeout(t);
  }, [fetchList]);

  // Content style
  const contentStyle = isMobile 
    ? {} 
    : { marginLeft: "250px", marginRight: "20px" };

  // Table headers
  const tableHeaders = isMobile 
    ? ['No.', 'Nama Pemohon', 'Status', 'Aksi']
    : ['No.', 'Nama Pemohon', 'Kecamatan', 'Kelurahan/Desa', 'Jenis Bantuan', 'Nominal', 'Progress', 'Status', 'Aksi'];

  return (
    <div className="table-responsive rounded border">
      <div className="main-content" style={contentStyle}>
        <Box sx={{ p: { xs: 1, sm: 2, md: 3 } }}>
          
          {/* Header */}
          <Box sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: 1, 
            mb: 2, 
            justifyContent: 'space-between', 
            flexWrap: 'wrap' 
          }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Engineering color="primary" />
              <Typography variant={isMobile ? "h6" : "h5"} fontWeight={700}>
                Monitoring Bantuan
              </Typography>
            </Box>
            <Button 
              variant="outlined" 
              startIcon={<Refresh />} 
              size="small"
              onClick={() => { fetchStats(); fetchList(); }}
            >
              Muat Ulang
            </Button>
          </Box>

          {/* Stat Cards */}
          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid item xs={6} sm={6} md={3}>
              <StatCard 
                icon={<HomeWork />} 
                label="Total Seluruh Bantuan" 
                value={stats?.totalBantuan ?? 0} 
                color="primary" 
              />
            </Grid>
            <Grid item xs={6} sm={6} md={3}>
              <StatCard 
                icon={<HourglassEmpty />} 
                label="Dalam Proses"
                value={(stats?.statusProses?.['Dalam Proses']) ?? 0} 
                color="warning" 
              />
            </Grid>
            <Grid item xs={6} sm={6} md={3}>
              <StatCard 
                icon={<CheckCircle />} 
                label="Selesai"
                value={(stats?.statusProses?.['Selesai']) ?? 0} 
                color="success" 
              />
            </Grid>
            <Grid item xs={6} sm={6} md={3}>
              <StatCard 
                icon={<ReportProblem />} 
                label="Total Keluhan"
                value={stats?.totalKeluhan ?? 0} 
                color="error" 
              />
            </Grid>
          </Grid>

          {/* Bantuan per Jenis */}
          {stats?.bantuanPerJenis?.length > 0 && (
            <Card elevation={2} sx={{ mb: 3 }}>
              <CardContent sx={{ p: { xs: 1.5, sm: 2 } }}>
                <Typography variant="overline" color="text.secondary">
                  Bantuan per Jenis
                </Typography>
                <Stack
                  direction={{ xs: 'column', sm: 'row' }}
                  spacing={1}
                  sx={{ mt: 1, flexWrap: 'wrap', gap: 1 }}
                >
                  {stats.bantuanPerJenis.map((b) => (
                    <Chip
                      key={b.JenisBantuan}
                      label={`${String(b.JenisBantuan || '').replace(/^Rehab/i, 'Rehabilitasi')}: ${b.jumlah} (${formatRp(b.totalNominal)})`}
                      color="primary"
                      variant="outlined"
                      size={isMobile ? "small" : "medium"}
                      sx={{
                        maxWidth: '100%',
                        height: 'auto',
                        '& .MuiChip-label': { whiteSpace: 'normal', wordBreak: 'break-word', py: 0.5, display: 'block' },
                      }}
                    />
                  ))}
                </Stack>
              </CardContent>
            </Card>
          )}

          {/* Filter Bar */}
          <FilterBar 
            filters={filters}
            onChange={setFilters}
            onReset={resetFilters}
            isMobile={isMobile}
            filterCount={filterCount}
          />

          {/* Data Table */}
          <Card elevation={2}>
            <CardContent sx={{ p: { xs: 1, sm: 2 } }}>
              <Typography variant="overline" color="text.secondary" sx={{ mb: 1, display: 'block' }}>
                Daftar Monitoring ({totalItems} data)
              </Typography>

              {/* Loading */}
              {loading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
                  <CircularProgress size={32} />
                </Box>
              ) : rows.length === 0 ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
                  <Typography color="text.secondary">Tidak ada data yang ditemukan</Typography>
                </Box>
              ) : isMobile ? (
                // Mobile View - Cards
                <Box>
                  {rows.map((row, i) => (
                    <MonitoringRow 
                      key={row.id || row.bantuan?.id || i}
                      row={row}
                      index={i}
                      page={page}
                      limit={limit}
                      onViewDetail={handleViewDetail}
                    />
                  ))}
                </Box>
              ) : (
                // Desktop View - Table
                <Box sx={{ overflowX: 'auto' }}>
                  <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
                    <thead style={{ backgroundColor: '#f5f7fa' }}>
                      <tr>
                        {tableHeaders.map((h) => (
                          <th key={h} style={{ 
                            textAlign: 'left', 
                            padding: '10px', 
                            borderBottom: '1px solid #e0e0e0',
                            fontWeight: 600,
                            fontSize: 13
                          }}>
                            {h}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {rows.map((row, i) => (
                        <MonitoringRow 
                          key={row.id || row.bantuan?.id || i}
                          row={row}
                          index={i}
                          page={page}
                          limit={limit}
                          onViewDetail={handleViewDetail}
                        />
                      ))}
                    </tbody>
                  </table>
                </Box>
              )}

              {/* Pagination */}
              {rows.length > 0 && (
                <Box sx={{ 
                  display: 'flex', 
                  flexDirection: isMobile ? 'column' : 'row',
                  justifyContent: 'space-between', 
                  alignItems: isMobile ? 'stretch' : 'center', 
                  mt: 2, 
                  gap: 1 
                }}>
                  <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
                    <Box component="select" 
                      value={limit}
                      onChange={(e) => { setLimit(Number(e.target.value)); setPage(1); }}
                      sx={{ 
                        px: 1.5, 
                        py: 0.8, 
                        border: '1px solid #ccc', 
                        borderRadius: 1, 
                        fontSize: 14,
                        bgcolor: 'white'
                      }}
                    >
                      {[10, 25, 50].map((n) => <option key={n} value={n}>{n}</option>)}
                    </Box>
                    <Typography variant="body2" color="text.secondary">
                      Hal. {page} dari {totalPages} • {totalItems} data
                    </Typography>
                  </Stack>
                  
                  <Stack direction="row" spacing={1} justifyContent={isMobile ? 'center' : 'flex-end'}>
                    <Button 
                      variant="outlined" 
                      size="small" 
                      startIcon={<NavigateBefore />}
                      disabled={page <= 1}
                      onClick={() => setPage((p) => Math.max(1, p - 1))}
                      fullWidth={isMobile}
                    >
                      {!isMobile && 'Prev'}
                    </Button>
                    <Button 
                      variant="outlined" 
                      size="small" 
                      endIcon={<NavigateNext />}
                      disabled={page >= totalPages}
                      onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
                      fullWidth={isMobile}
                    >
                      {!isMobile && 'Next'}
                    </Button>
                  </Stack>
                </Box>
              )}
            </CardContent>
          </Card>

          {/* Detail Dialog (now separate page /monitoring-bantuan/:id) */}
          {/* <DetailMonitoringDialog 
            open={detailOpen}
            onClose={() => setDetailOpen(false)}
            bantuanId={selectedId}
          /> */}

          {/* Snackbar */}
          <Snackbar 
            open={snackbar.open} 
            autoHideDuration={4000}
            onClose={() => setSnackbar((s) => ({ ...s, open: false }))}
            TransitionComponent={Fade} 
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          >
            <Alert 
              onClose={() => setSnackbar((s) => ({ ...s, open: false }))}
              severity={snackbar.severity} 
              variant="filled" 
              sx={{ width: '100%' }}
            >
              {snackbar.message}
            </Alert>
          </Snackbar>
        </Box>
      </div>
    </div>
  );
};

export default MonitoringBantuan;
